module.exports = __webpack_public_path__ + "static/media/i.ffae53ac.png";